import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const noticeApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/notices/`,
      {params: params})
  },
  detail (noticeId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/notices/${noticeId}/`,
      {params: params})
  },
  create (params) {
    // 创建新公告
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/notices/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/notices/`, querystring.stringify(params))
  },
  update (noticeId, params) {
    // 更新公告
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/notices/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/notices/${noticeId}/`, querystring.stringify(params))
  },
  delete (noticeId) {
    window.console.log("发起删除请求")
    return axios.delete(
      `${ApiSetting.baseUrl}/api/notices/${noticeId}/`
    )
  }
}

export default noticeApi
